<script setup lang="ts">
import BadgeCheckbox from '../shared/BadgeCheckbox.vue'
import ElementalBadage from './ElementalBadage.vue'
import { ElementalTypeEnum } from '~~/src/types/elemental'
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'

const { state, toggleFilter, activeAll } = useElementalListsStore()

const listOption = computed(() => {
  return state.viewsActives?.[ElementalTypeEnum.List] ?? null
})
const isAllActive = computed(() => state.isAllActive)
</script>

<template>
  <div
    v-if="state.viewsActives"
    class="flex gap-1 px-2 w-full mt-1 pb-2"
  >
    <BadgeCheckbox
      v-if="state.query === ''"
      class="flex-nowrap flex-shrink-0"
      :is-all="true"
      :model-value="isAllActive"
      :is-all-selected="isAllActive"
      @update:model-value="activeAll"
    >
      All
    </BadgeCheckbox>
    <template
      v-for="item in state.viewsActives"
      :key="item?.elementaltype"
    >
      <template v-if="item && item.elementaltype !== ElementalTypeEnum.List">
        <ElementalBadage
          :type="item.elementaltype"
          class="flex-nowrap flex-shrink-0"
          :is-all-active="isAllActive"
        />
      </template>
    </template>
    <template v-if="listOption">
      <BadgeCheckbox
        v-if="state.query === '' || (listOption.count > 0) "
        class="flex-nowrap flex-shrink-0"
        :is-all-selected="isAllActive"
        :model-value="listOption.filterActive"
        @update:model-value="toggleFilter(listOption.elementaltype)"
      >
        <template #default="{ isChecked }">
          <span>
            {{ listOption.label }}

          </span>
          <BubbleCount
            v-if="state.query !== '' && listOption.count > 0"
            :is-active="isChecked"
          >
            {{ listOption.count }}
          </BubbleCount>
        </template>
      </BadgeCheckbox>
    </template>
  </div>
</template>
